<template>
  <v-alert
    color="primary"
    dense
    outlined
    type="info"
    class="mt-6"
  >
    {{ title }}
  </v-alert>
</template>

<script>
export default {
  name: 'UIAlert',

  props: {
    title: String
  }
}
</script>
